import { closeWindow } from './close-window';

export const config : any = {
  md5: '0b28a5799a32c687dad2c5183718ceac',    //  ?developerTool=*****
  ondevtoolopen: closeWindow,                 // ondevtoolopen 優先級高於 url
  url: 'closeDevTools',
  tkName: 'developerTool',
  interval: 200,
  stopIntervalTime: 5000,                     // 在移動端時取消監視的等待時長
  detectors: [0, 1, 3, 4, 5, 6, 7],           // 'all', ! 默認去掉 sizeDetector 因為會誤傷
  clearLog: true,
  disableIframeParents: true,
  isSuperAdmin: false,
  // 以下如需開啟, 可參考 https://github.com/theajack/disable-devtool/tree/master 修改
  // ondevtoolclose: null,                    // ondevtoolclose 監聽
  // timeOutUrl: '',
  // clearIntervalWhenDevOpenTrigger: true,   // 是否在觸發之後停止監控
  // disableMenu: true,                       // 是否禁用右鍵
  // disableSelect: false,
  // disableCopy: false,
  // disableCut: false,
  // disablePaste: false,
  // ignore: null,
  // seo: true,
}
